import React from "react";
import ReactDOM from "react-dom";
import { initializeTheme } from "sprint-common-web";

import { App } from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

initializeTheme();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sprint-service-worker.js`).catch(console.error);
    });
}
